export enum HouseholdComparisonDetailViewMode {
    TOTAL = 'TOTAL',
    APPLIANCES = 'APPLIANCES',
    RANKING = 'RANKING',
}
